import { LOCAL_STORAGE_KEYS } from "../constants";

/**
 * Optimized utility functions for managing sidebar state persistence
 */

export const getSidebarExpandedState = (): boolean => {
  try {
    const saved = localStorage.getItem(LOCAL_STORAGE_KEYS.SIDEBAR_EXPANDED);
    return saved !== null ? JSON.parse(saved) : true;
  } catch {
    return true;
  }
};

export const setSidebarExpandedState = (expanded: boolean): void => {
  try {
    localStorage.setItem(LOCAL_STORAGE_KEYS.SIDEBAR_EXPANDED, JSON.stringify(expanded));
  } catch {
    // Silently fail if localStorage is not available
  }
};

export const getSidebarOpenMenus = (): Record<string, boolean> => {
  try {
    const saved = localStorage.getItem(LOCAL_STORAGE_KEYS.SIDEBAR_OPEN_MENUS);
    return saved !== null ? JSON.parse(saved) : {};
  } catch {
    return {};
  }
};

export const setSidebarOpenMenus = (openMenus: Record<string, boolean>): void => {
  try {
    localStorage.setItem(LOCAL_STORAGE_KEYS.SIDEBAR_OPEN_MENUS, JSON.stringify(openMenus));
  } catch {
    // Silently fail if localStorage is not available
  }
};
